/**
 * Breadcrumb URL for an area/parent item: the region-absolute seo_pages.path carried by
 * the item's public category for the current categoryPath is the single source of truth,
 * rendered verbatim — no client-side slug/path building. An item may instead carry a
 * ready-to-render `url` directly (e.g. the synthetic country crumb, which carries the
 * current category search path).
 *
 * Fallback (in transition, for ES documents indexed before publicCategories carried url):
 * the legacy category+slug build. Callers wrap the result in regionRelativeUrl, which is
 * idempotent on the absolute value, so no double region prefix.
 */
export function breadcrumbUrl(item, categoryPath) {
    const publicCategory = (item.publicCategories || []).find((category) => category.path === categoryPath);

    if (publicCategory && publicCategory.url) {
        return publicCategory.url;
    }

    if (item.url) {
        return item.url;
    }

    return `${categoryPath}${item.slug ? `${item.slug}/` : ''}`;
}
